import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import {
  alertSources,
  DEFAULT_SELECTED_ALERT_SOURCES,
} from 'features/Weather/features/WeatherAlerts/config/alertSources.config';

/**
 * Renders the searchable source multi-select and reports source changes.
 *
 * @param {{selectedSources?: string[], onChange: (selectedSources: string[]) => void}} props - Current selections and their update callback.
 * @returns {JSX.Element} The source multi-select control.
 */
const AlertSourceFilter = ({ selectedSources = DEFAULT_SELECTED_ALERT_SOURCES, onChange }) => {
  const options = alertSources.map(({ id, label }) => ({ value: id, label }));
  const selectedOptions = options.filter(({ value }) => selectedSources.includes(value));

  return (
    <div style={{ width: 'clamp(220px, 25vw, 320px)', flexShrink: 0 }}>
      <BaseSelect
        inputId="weather-alert-sources-filter"
        wrapperClassName="w-100"
        isMulti
        isSearchable
        isClearable
        classNames={{
          control: () => 'bg-primary',
        }}
        selectProps={{
          'aria-label': 'Alert sources',
          options,
          value: selectedOptions,
          placeholder: 'Alert Sources',
          onChange: (nextOptions) => onChange((nextOptions ?? []).map(({ value }) => value)),
        }}
      />
    </div>
  );
};

export default AlertSourceFilter;
